<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="问题内容：" prop="questionContent" class="width100">
          <el-input v-model="form.questionContent" placeholder="请输入问题内容" :rows="6" type="textarea" maxlength="1000" show-word-limit />
        </el-form-item>
        <el-form-item label="图片：" prop="imgUrl">
          <moreImageUpload v-model="form.imgUrl" :limit="6" hintText="建议尺寸680x860像素以上" />
          <!-- <div class="flexs">
            <imageUpload v-model="form.imgUrl" width="42" height="42" />
            <span class="hint hint1">限制上传1张<br />建议尺寸680x860像素以上</span>
          </div> -->
        </el-form-item>
        <el-form-item label="状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>{{form.state?'启用':'禁用'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import courseScenarioExerciseApi from '@/api/course/courseScenarioExercise'
import ImageUpload from "@/components/ImageUpload";
import MoreImageUpload from "@/components/MoreImageUpload";
function initFormBean() {
  const formBean = {
    id: null,
    questionContent: null,
    imgUrl: [],
    state: 0,
  }
  return formBean
}

export default {
  components: { ImageUpload, MoreImageUpload },
  data() {
    return {
      categorizepProps: {
        label: 'name',
        value: 'id',
        children: 'child',
        multiple: true
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        questionContent: [{ required: true, message: '请输入问题内容', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      this.$set(this.form, 'imgUrl', this.clacArrObj(row.imgUrl));
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    clacArrObj(str) {
      if (!str) return []
      let arr = str.split(',')
      let newArr = []
      arr.forEach(item => {
        newArr.push({ url: item })
      })
      return newArr
    },
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.imgUrl = params.imgUrl && params.imgUrl.length ? params.imgUrl.map(banner => banner.url).toString() : '';
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseScenarioExerciseApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseScenarioExerciseApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
